const dogs = [
  {
    id: 2,
    name: "Jake",
    breed: "Mix",
    age: "Unknown",
    sex: "Male", // "Male" or "Female"
    size: "Medium", // "Small", "Medium", or "Large"
    status: "Available", // "Available" or "On Hold"
    img: "/dogs/jake.png",
  },

  {
    id: 4,
    name: "Hazel",
    breed: "Sharpei Mix",
    age: "Unknown",
    sex: "Female", // "Male" or "Female"
    size: "Medium", // "Small", "Medium", or "Large"
    status: "Available", // "Available" or "On Hold"
    img: "/dogs/flop.png",
  },
  {
    id: 6,
    name: "June",
    breed: "Shepherd Mix",
    age: "2 years",
    sex: "Female",
    size: "Medium",
    status: "Available",
    img: "/dogs/lola2.png",
  },
  {
    id: 10,
    name: "Mustang",
    breed: "Mix",
    age: "Unknown",
    sex: "Female",
    size: "Medium",
    status: "Available",
    img: "/dogs/mustang.png",
  },
  {
    id: 11,
    name: "Peter",
    breed: "Mix",
    age: "Unknown",
    sex: "Male",
    size: "Medium",
    status: "Available",
    img: "/dogs/peter.png",
  },
  {
    id: 13,
    name: "Ash",
    breed: "Mix",
    age: "1 1/2 years",
    sex: "Female",
    size: "Medium",
    status: "Available",
    img: "/dogs/daisy.png",
  },
  {
    id: 16,
    name: "Hunter",
    breed: "Mix",
    age: "Unknown",
    sex: "Male",
    size: "Medium",
    status: "Available",
    img: "/dogs/Hunter.png",
  },
  {
    id: 17,
    name: "Astra",
    breed: "Mix",
    age: "3 years",
    sex: "Male",
    size: "Medium",
    status: "Available",
    img: "/dogs/Patches.png",
  },
  {
    id: 18,
    name: "Lucy",
    breed: "Mix",
    age: "Unknown",
    sex: "Female",
    size: "Medium",
    status: "Available",
    img: "/dogs/Brownie.png",
  },
  {
    id: 22,
    name: "Ash",
    breed: "Mix",
    age: "1 1/2 years",
    sex: "Female",
    size: "Medium",
    status: "Available",
    img: "/dogs/Crumpet.png",
  },
  {
    id: 27,
    name: "Zero",
    breed: "Mix",
    age: "Unknown",
    sex: "Male",
    size: "Medium",
    status: "Available",
    img: "/dogs/Murphy.png",
  },
  {
    id: 30,
    name: "Cash",
    breed: "Mix",
    age: "1-2 years",
    sex: "Male",
    size: "Medium",
    status: "Available",
    img: "/dogs/Winston.png",
  },
  {
    id: 37,
    name: "Bluey",
    breed: "Mix",
    age: "Unknown",
    sex: "Male",
    size: "Medium",
    status: "Available",
    img: "/dogs/Bluey.png",
  },
  {
    id: 38,
    name: "Bossman",
    breed: "Mix",
    age: "Unknown",
    sex: "Male",
    size: "Medium",
    status: "Available",
    img: "/dogs/Bossman.png",
  },
  {
    id: 40,
    name: "Brindle",
    breed: "Mix",
    age: "Unknown",
    sex: "Female",
    size: "Medium",
    status: "Available",
    img: "/dogs/Brindle.png",
  },
  {
    id: 45,
    name: "Talia",
    breed: "Mix",
    age: "2-3 years",
    sex: "Female",
    size: "Medium",
    status: "Available",
    img: "/dogs/Talia.png",
  },
  {
    id: 46,
    name: "Brody",
    breed: "Mix",
    age: "2-3 years",
    sex: "Male",
    size: "Medium",
    status: "Available",
    img: "/dogs/Brody.png",
  },
  {
    id: 47,
    name: "Nashville",
    breed: "Mix",
    age: "2 years",
    sex: "Female",
    size: "45 lbs",
    status: "Available",
    img: "/dogs/Nashville.png",
  },
  {
    id: 48,
    name: "Memphis",
    breed: "Mix",
    age: "2 years",
    sex: "Female",
    size: "45 lbs",
    status: "Available",
    img: "/dogs/Memphis.png",
  },
  {
    id: 49,
    name: "Charlie",
    breed: "Mix",
    age: "2 years",
    sex: "Male",
    size: "Medium",
    status: "Available",
    img: "/dogs/Charlie.png",
  },
  {
    id: 51,
    name: "Hawk",
    breed: "Mix",
    age: "2 1/2 years",
    sex: "Male",
    size: "Medium",
    status: "Available",
    img: "/dogs/Hawk.png",
  },
  {
    id: 52,
    name: "Dexter",
    breed: "Mix",
    age: "6 months",
    sex: "Male",
    size: "23 lbs",
    status: "Available",
    img: "/dogs/Dexter.png",
  },
  {
    id: 54,
    name: "Crow",
    breed: "Mix",
    age: "2-3 years",
    sex: "Male",
    size: "Large",
    status: "Available",
    img: "/dogs/Crow.png",
  },
];

export default dogs;
